import React, { useState, useEffect } from "react";
import {
    Form,
    Row,
    Col,
    Skeleton,
    Select,
    Input,
    Button,
    Modal,
    InputNumber,
    Alert
} from "antd";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import moment from "moment-jalaali";

function BthDayMessage() {


    const CREATEMESSAGE = gql`
  mutation createMessage($createInput: CreateMessageInput!) {
  createMessage(createInput: $createInput) {
    id
  }
}
  `;
    const UPDATEMESSAGE = gql`
  mutation updateMessage($id: ID!, $updateInput: UpdateMessageInput!){
    updateMessage(id: $id, updateInput: $updateInput)
  }
  `
    const GETMESSAGE = gql`
    query {
        getBirthdayMessage{
            id
            createdAt
            title
            body
        }
    }
  `;

    const [oldMessageObj, setOldMessageObj] = useState(null);
    const [newMessageObj, setNewMessageObj] = useState(null);

    const [error, setError] = useState(null);
    const { TextArea } = Input;


    const [getBthMessage, bthMessageData] = useLazyQuery(
        GETMESSAGE,
        {
            onCompleted({ getBirthdayMessage }) {
                setOldMessageObj(getBirthdayMessage)
            },
        }
    );


    const [form] = Form.useForm();

    useEffect(() => {
        form.setFieldsValue(oldMessageObj);
    }, [oldMessageObj]);


    const [runUpdateBthMessage, updateBthMessage] = useMutation(UPDATEMESSAGE, {
        onCompleted(data) {
            Modal.success({
                title: "موفق",
                content: "پیام تولد بروزرسانی شد",
                bodyStyle: { direction: "rtl" },
                okText: "باشه",
            });

        },
        onError(err) {
            console.log("خطا: " + err.message);
            Modal.error({
                title: "مشکلی پیش آمده!",
                content: err.message,
                bodyStyle: { direction: "rtl" },
                okText: "باشه",
            });
        },
    });
    const [runCreateBthMessage, createBthMessage] = useMutation(CREATEMESSAGE, {
        fetchPolicy: "no-cache",
        onCompleted(data) {
            Modal.success({
                title: "موفق",
                content: "پیام تولد ایجاد شد",
                bodyStyle: { direction: "rtl" },
                okText: "باشه",
            });

        },
        onError(err) {
            console.log("خطا: " + err.message);
            Modal.error({
                title: "مشکلی پیش آمده!",
                content: err.message,
                bodyStyle: { direction: "rtl" },
                okText: "باشه",
            });
        },
    });

    useEffect(() => {
        getBthMessage();
    }, []);

    const doHandleBthMessage = (messageInput) => {
        if (oldMessageObj === null)
            runCreateBthMessage({
                variables: {
                    createInput: {
                        ...messageInput,
                        type: 'BIRTHDAY'
                    },
                },
            });
        else {
            runUpdateBthMessage({
                variables: {
                    id: oldMessageObj.id,
                    updateInput: {
                        ...messageInput,
                        type: 'BIRTHDAY'
                    },
                },
            })
        }
    };
    if (getBthMessage.loading)
        return (
            <>
                <Skeleton active round />
                <br />
                <Skeleton active round />
            </>
        );

    return (
        <>
            <Form layout="vertical" onFinish={doHandleBthMessage} form={form}>
                <Row>
                    <Col xs={12} md={12}>
                        <Row>
                            <Form.Item
                                name="title"
                                id="title"
                                style={{ width: "100%" }}
                                label="عنوان"
                                rules={[
                                    {
                                        required: true,
                                        message: "لطفا عنوان را وارد کنید!",
                                    },
                                ]}
                                validateStatus={error && "error"}
                            >
                                <Input className="form-input" placeholder={"عنوان"} />
                            </Form.Item>
                        </Row>

                        <Row>
                            <Form.Item
                                name="body"
                                id="body"
                                style={{ width: "100%" }}
                                label="پیام تولد"
                                rules={[
                                    {
                                        required: true,
                                        message: "لطفا پیام را وارد کنید!",
                                    },
                                ]}
                                validateStatus={error && "error"}
                            >
                                <TextArea placeholder="پیام تولد" rows={3} />

                            </Form.Item>
                        </Row>


                    </Col>

                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <Alert
                            description="USER_NAME = نام و نام خانوادگی"
                            type="info"
                            banner
                            style={{ width: "100%", marginBottom: "30px" }}
                        /></Col>
                </Row>
                <Button
                    type="primary"
                    htmlType="submit"
                    loading={runCreateBthMessage.loading || runUpdateBthMessage.loading && true}
                >
                    ثبت
                </Button>
            </Form>
        </>
    );
}

export default BthDayMessage;
